//TODO: Move out of utils
import Vue from "vue";
import bindDirectives from "./directives";
import bindPlugins from "./plugins";
import bindFilters from "./filters";
import bindComponents from "./components";
import bindCustom from "./custom";
export default () => {
  bindPlugins(Vue);
  bindDirectives(Vue);
  bindFilters(Vue);
  bindComponents(Vue);
  bindCustom(Vue);
};